import React from 'react';
import { connect } from 'react-redux';
import { hashHistory, Link } from 'react-router';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Header from '../Components/Header/HeaderUnauthorized';
import HeaderSmall from '../Components/Header/HeaderSmall';
import RaisedButton from 'material-ui/RaisedButton';
import { resourceApi } from '../utils/fetchUtil';



class SupportPage extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            ClientUserID: undefined,
            EmailAddress: undefined,
            FirstName: "",
            LastName: "",
            Employer: "",
            SupportSubjectID: "",
            Message: "",
            external: props.location.pathname == '/go/support' ? true : false,
            returnTo: props.location.pathname == '/go/support' ? 'Back to Login' : 'Back to Account',
            isSubmitted: false,

        }
    }


    componentDidMount = () => {
        console.log(this.props)
        this.setUserInfo();
        this.getSupportSubjects();
    }

    setUserInfo() {
        if (this.props.member != null) {
            this.setState({
                ClientUserID: this.props.member.ClientUserID,
                FirstName: this.props.member.FirstName,
                LastName: this.props.member.LastName,
                EmailAddress: this.props.member.EmailAddress,
                Employer: this.props.member.Employer,
            })
        }
    }

    getSupportSubjects = () => {
        let config = {
            method: 'get',
            url: `support/subjects`
        }
        resourceApi(config)
            .then(res => {
                this.setState({ options: res.data })
            })
            .catch((err) => {
                console.log("Error", err)
            })
    }


    handleChangeSubject = (event, index, value) => {
        this.setState({ Subject: value })
        this.setState({ SupportSubjectID: this.state.options[index]["SupportSubjectID"] })
        if (value.length < 1) {
            this.setState({ errorSubject: "Required" })
        }
        else {
            this.setState({ errorSubject: undefined })
        }
    }

    handleChangeMessage = (event, value) => {
        this.setState({ Message: value })
        if (value.length < 1 || value.length > 500) {
            this.setState({ errorMessage: "Required, May not exceed 500 characters." })
        }
        else {
            this.setState({ errorMessage: undefined })
        }
    }

    handleChangeFirstName = (event, value) => {
        this.setState({ FirstName: value })
    }

    handleChangeLastName = (event, value) => {
        this.setState({ LastName: value })
    }

    handleChangeEmployer = (event, value) => {
        this.setState({ Employer: value })
    }

    handleChangeEmail = (event, value) => {
        this.setState({ EmailAddress: value })
        if (!/.+@.+\..+$/.test(value)) {
            this.setState({ errorEmailAddress: "Valid Email Required" })
        }
        else {
            this.setState({ errorEmailAddress: undefined })
        }
    }

    handleSubmit = (event, value) => {
        let config = {
            method: 'post',
            url: `support/ticket`,
            data: {
                ClientUserID: this.state.ClientUserID,
                ClientID: this.state.ClientID,
                FirstName: this.state.FirstName,
                LastName: this.state.LastName,
                Employer: this.state.Employer,
                EmailAddress: this.state.EmailAddress,
                SubjectID: this.state.SupportSubjectID,
                Message: this.state.Message,
            }
        };
        // console.log(config);
        resourceApi(config)
            .then((res) => {
                this.setState({ isSubmitted: true })
                // console.log(res);
            })
            .catch((err) => {
                console.log(err)
                this.setState({ isSubmitted: false })
            })

    }

    handleReturn = () => {
        if (this.state.external) {
            hashHistory.push('/');
        }
        else {
            hashHistory.push('/account');
        }
    }

    render() {
        const styleWhite = {
            color: "#fff"
        };

        return (
            <div>
                {!this.state.external && (
                    <HeaderSmall title="Contact Support" />
                )}
                {this.state.external && (
                    <Header>
                        <span className="white" >Contact Support</span>
                    </Header>
                )}
                <br />
                <br />

                {!this.state.isSubmitted && (
                    <div style={{
                        width: '80%',
                        margin: 'auto',
                        'border-radius': '5px',
                        'backgroundColor': 'rgba(0, 0, 0, 0.4)'
                    }}>

                        <form className="container">
                            {this.state.external && (
                                <div>
                                    <div>
                                        <TextField
                                            style={{ display: 'inline-block', width: '48%', margin: '0 1%' }}
                                            id="firstname-text-field"
                                            floatingLabelText="First Name"
                                            floatingLabelFixed={true}
                                            floatingLabelStyle={styleWhite}
                                            value={this.state.FirstName}
                                            onChange={this.handleChangeFirstName}
                                            fullWidth={true}
                                            inputStyle={styleWhite}
                                            autoCapitalize="none"
                                        />

                                        <TextField
                                            style={{ display: 'inline-block', width: '48%', margin: '0 1%' }}
                                            id="lastname-text-field"
                                            floatingLabelText="Last Name"
                                            floatingLabelFixed={true}
                                            floatingLabelStyle={styleWhite}
                                            value={this.state.LastName}
                                            onChange={this.handleChangeLastName}
                                            fullWidth={true}
                                            inputStyle={styleWhite}
                                            autoCapitalize="none"
                                        />

                                    </div>

                                    <TextField
                                        id="email-text-field"
                                        floatingLabelText="Email Address"
                                        floatingLabelFixed={true}
                                        floatingLabelStyle={styleWhite}
                                        value={this.state.EmailAddress}
                                        onChange={this.handleChangeEmail}
                                        fullWidth={true}
                                        inputStyle={styleWhite}
                                        autoCapitalize="none"
                                        errorText={this.state.errorEmailAddress}
                                        type="email"
                                    />

                                    <TextField
                                        id="employer-text-field"
                                        floatingLabelText="Employer"
                                        floatingLabelFixed={true}
                                        floatingLabelStyle={styleWhite}
                                        value={this.state.Employer}
                                        onChange={this.handleChangeEmployer}
                                        fullWidth={true}
                                        inputStyle={styleWhite}
                                        autoCapitalize="none"
                                    />
                                </div>
                            )}

                            <SelectField
                                id="subject-select-field"
                                floatingLabelText="Subject"
                                floatingLabelFixed={true}
                                floatingLabelStyle={styleWhite}
                                value={this.state.Subject}
                                onChange={this.handleChangeSubject}
                                inputStyle={styleWhite}
                                fullWidth={true}
                                labelStyle={{ color: '#fff' }}
                                maxHeight={200}
                                errorText={this.state.errorSubject}
                            >
                                {this.state.options && this.state.options.length > 0 && (
                                    this.state.options.map(opt => {
                                        return <MenuItem value={opt.SupportSubjectID} primaryText={opt.SupportSubjectDesc} />;
                                    }))}
                            </SelectField>

                            <TextField
                                id="message-text-field"
                                floatingLabelText="Description"
                                floatingLabelFixed={true}
                                floatingLabelStyle={styleWhite}
                                value={this.state.Message}
                                onChange={this.handleChangeMessage}
                                fullWidth={true}
                                multiLine={true}
                                rows={3}
                                textareaStyle={{ backgroundColor: 'white', 'border-radius': '5px', padding: '0 5px' }}
                                errorText={this.state.errorMessage}
                            />
                            <br />
                            {this.state.EmailAddress && this.state.SupportSubjectID && this.state.Message && (
                                <RaisedButton label="Submit" primary={true} onClick={this.handleSubmit} fullWidth={true} style={{ height: 45, borderRadius: '5px' }} labelStyle={{ fontSize: '26px' }} />
                            )}
                        </form>
                    </div>


                )}
                {this.state.isSubmitted && (
                    <div style={{
                        width: '80%',
                        padding: '10% 0%',
                        margin: 'auto',
                        textAlign: 'center',
                        'border-radius': '5px',
                        'backgroundColor': 'rgba(0, 0, 0, 0.4)'
                    }}>
                        <p><span style={{ color: "white" }}>Successfully Submitted</span></p>
                        <br />
                        <RaisedButton label={this.state.returnTo} primary={true} onClick={this.handleReturn} fullWidth={false} style={{ height: 35, borderRadius: '5px' }} labelStyle={{ fontSize: '22px' }} />
                    </div>
                )}
            </div>
        )
    }
}
const mapStateToProps = (state) => ({
    member: state.thisApp.auth.member
})

export default connect(
    mapStateToProps
)(SupportPage)


// WEBPACK FOOTER //
// ./src/Pages/Support.js